var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BadgeState',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.errorMessage),expression:"errorMessage"}],attrs:{"color":_vm.stateBackground,"label":_vm.stateDisplay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }